import { render, staticRenderFns } from "./AdminSemester.vue?vue&type=template&id=2dfdbeb7&scoped=true"
import script from "./AdminSemester.vue?vue&type=script&lang=js"
export * from "./AdminSemester.vue?vue&type=script&lang=js"
import style0 from "./AdminSemester.vue?vue&type=style&index=0&id=2dfdbeb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfdbeb7",
  null
  
)

export default component.exports